import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';

var PendingTag = function PendingTag() {
  return import('~/components/functional/TcVars/PendingTag.vue');
};

export default {
  name: 'CommercialRibbon',
  components: {
    PendingTag: PendingTag
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    locale: {
      type: Object,
      required: true
    },
    trackingEventCategory: {
      type: String,
      required: true
    }
  },
  computed: {
    type: function type() {
      return this.payload.url ? 'a' : 'span';
    },
    displayTracking: function displayTracking() {
      return {
        data: {
          event_category: "".concat(this.trackingEventCategory),
          event_action: 'Display_banner',
          event_label: "".concat(this.payload.label),
          event_is_non_interactive: 1
        }
      };
    },
    href: function href() {
      if (!this.payload.url) return null;
      return this.payload.url.replace(':market', this.locale.market).replace(':language', this.locale.language);
    }
  },
  methods: {
    clickTracking: function clickTracking(evt) {
      this.$root.$emit('generic-tracking', evt, {
        data: {
          event_category: this.trackingEventCategory,
          event_action: 'Click_banner',
          event_label: this.payload.label
        }
      });
    }
  }
};